import { CommonModule } from '@angular/common';
import { ComponentFactory, ComponentFactoryResolver, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { DxDataGridModule } from 'devextreme-angular'; //TODO should be removed once refactoring complete
import { MatGridComponent } from '../../../material/src/matGrid/matGrid.component';
import { AbcGridComponent } from './abcGrid.component';

@NgModule({
  imports: [BrowserModule, CommonModule, ReactiveFormsModule, MatPaginatorModule, MatTableModule],
  declarations: [AbcGridComponent, MatGridComponent],
  exports: [AbcGridComponent, DxDataGridModule],
  bootstrap: [AbcGridComponent],
})
export class AbcGridModule {
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}
  public resolveComponent(): ComponentFactory<AbcGridComponent> {
    return this.componentFactoryResolver.resolveComponentFactory(AbcGridComponent);
  }
}
